/* 
  JS Coding conventions:
    Before adding new JS, check assets/dawn-js-guide.js
    Focus on liquid over JavaScript (with exceptions on excessive complexity)
    For large JS functions that aren't needed on page load, load them from a separate file as a module
    If a componenet uses a function in this file, add comment:
    {% comment %} fostr - uses: assets/wc-global.js/wcClassToggle {% endcomment %} 

  Naming conventions:
    Append 'wc' to core functions and brand initals for brand-specific JS
    inner funtions:
      - when called inside function to handle something: handleSomething ()
      - when triggered by an event: onSomeevent ()

  Web-components:
    wcClassToggle - allows an element to toggle a class on itself or another element
    wcUpdateDataAttribute - allows an element to update a data-attribute of another element
    wcAccordion - creates an accordion that keeps one item open
    wcVideoContainer - creates video from shopify files with custom controls

  Functions:
    wcIsVisible - adds a class to the body tag when an element is visible
*/

//--- Global variables ---//
let api_token = '';
switch(window.Shopify.shop) {
  case 'kjaerweis-develop.myshopify.com':
    api_token = '2c5384ec3f976b56f961bb2d2ca7d718'; // Dev Store
    break;
}

window.API_VERSION = '2022-07';
window.API_ACCESS = api_token;

// <wc-class-toggle data-toggle-class="active" data-toggle-element="#menu">...</wc-class-toggle>
// <wc-class-toggle></wc-class-toggle> (defaults to itself and 'active')
class wcClassToggle extends HTMLElement {
  constructor() {
    super();
    this.onclick = () => {
      const toggleElement = this.dataset.toggleElement ? document.querySelector(this.dataset.toggleElement) : this;
      const toggleClass = this.dataset.toggleClass || 'active';
      toggleElement.classList.toggle(toggleClass);
    }
  }
}
window.customElements.define('wc-class-toggle', wcClassToggle);

class wcUpdateDataAttribute extends HTMLElement {
  constructor() {
    super();
    this.onclick = () => {
      const targetElement = document.querySelector(this.dataset.wcTargetElement);
      const dataAttribute = this.dataset.wcAttribute;
      const dataValue = this.dataset.wcValue;
      targetElement.dataset[dataAttribute] = dataValue;
    }
  }
}
window.customElements.define('wc-update-data-attribute', wcUpdateDataAttribute);

// see: snippets/wc-blocks-accordion.liquid for structure/usage
class wcAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordions = this.querySelectorAll('[data-wc-accordion]');
    this.watchTriggers();
  }
  watchTriggers() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-wc-accordion-trigger]')) {
        this.accordions.forEach(accordion => {
          if (accordion === event.target.closest('[data-wc-accordion]')) {
            accordion.classList.toggle('active');
          } else {
            accordion.classList.remove('active');
          }
        })
      }
    });
  }
}
window.customElements.define('wc-accordion', wcAccordion);

// see: section/wc-section-tabs.liquid for structure/usage
// Switches set of value in container (useful for tabs ect, try with CSS '+' sign selector)
class wcSwitchValues extends HTMLElement {
  constructor() {
    super();
    this.switchParent = this.dataset.wcSwitchParent ? this.closest(this.dataset.wcSwitchParent) : this;
    this.switchTriggers = this.querySelectorAll('[data-wc-switch-value]');
    this.watchTriggers();
  }
  watchTriggers() {
    this.addEventListener('click', (event) => {
      console.log('click')
      if (event.target.closest('[data-wc-switch-value]')) {
        const currentTrigger = event.target.closest('[data-wc-switch-value]');
        this.switchParent.dataset.wcCurrentValue = currentTrigger.dataset.wcSwitchValue;
        this.switchTriggers.forEach(switchTrigger => {
          switchTrigger === currentTrigger ? switchTrigger.classList.add('wc-active') : switchTrigger.classList.remove('wc-active');
        })
      }
    });
  }
}
window.customElements.define('wc-switch-values', wcSwitchValues);

// Wraps around the slider compnent to eneable autoplay (slider counter needed but can be hidden)
// <wc-auto-slider data-speed="{{ seconds }}"><slider-component></slider-component></wc-auto-slider>
class wcAutoSlider extends SliderComponent {
  constructor() {
    super();
    this.sliderComponent = this.querySelector('slider-component');
    this.sliderComponent.enableSliderLooping = true;
    this.autoplaySpeed = this.dataset.speed * 1000;
    this.play();
  }

  play() {
    this.sliderComponent.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  autoRotateSlides() {
    const step = 1;
    if (this.currentPageElement.innerText === this.sliderComponent.pageTotalElement.innerText || this.currentPageElement.innerText === this.previousSlide) {
      this.sliderComponent.slideScrollPosition = 0;
    } else {
      this.sliderComponent.slideScrollPosition = this.sliderComponent.slider.scrollLeft + (step * this.sliderComponent.sliderItemOffset);
    }
    this.sliderComponent.slider.scrollTo({
      left: this.sliderComponent.slideScrollPosition
    });
    this.previousSlide = this.currentPageElement.innerText + '';
  }
}
window.customElements.define('wc-auto-slider', wcAutoSlider);

// JS for custom video section/snippet
// see: snippets/wc-shopify-video-file.liquid for structure/usage
class wcVideoContainer extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('[data-wc-play-button]');
    this.muteButton = this.querySelector('[data-wc-mute-button]');
    if (this.playButton) this.watchControls();
  }
  watchControls() {
    this.playButton.addEventListener('click', (event) => {
      if (this.video.paused || this.video.ended) {
        this.playButton.setAttribute('data-state', 'pause');
        this.video.play();
      } else {
        this.playButton.setAttribute('data-state', 'play');
        this.video.pause();
      }
    });
    this.muteButton.addEventListener('click', (event) => {
      if (this.video.muted) {
        this.muteButton.setAttribute('data-state', 'unmuted');
        this.video.muted = false;
      } else {
        this.muteButton.setAttribute('data-state', 'muted');
        this.video.muted = true;
      }
    });
  }
}
window.customElements.define('wc-video-container', wcVideoContainer);

// Slide-in-menu
// Slide-in-menu
class wcHeaderDrawer extends HeaderDrawer {
  constructor() {
    super();
  }
}
window.customElements.define('wc-header-drawer', wcHeaderDrawer);

class wcCloseMenu extends HTMLElement {
  constructor() {
    super();
    if (this.closest('menu-drawer')) {
      this.addEventListener('click', () => this.closest('menu-drawer').close());
    } else {
      this.addEventListener('click', event => this.closest('header-drawer').closeMenuDrawer(event));
    }
  }
}
window.customElements.define('wc-close-menu', wcCloseMenu);


// <div data-is-visible="my-div">...</div>
// Adds/removes a class to the <body> tag when an element visible/gone from screen
window.addEventListener('load', () => {
  const wcIsVisible = (element, className) => {
    const isVisibleObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.body.classList.add(className);
        } else {
          document.body.classList.remove(className);
        }
      });
    });
    isVisibleObserver.observe(element);
  }
  document.querySelectorAll('[data-wc-is-visible]').forEach(element => {
    wcIsVisible(element, `is-visible--${element.dataset.wcIsVisible}`);
  });
});


// window.fostrFetch = payload => {
//   return fetch(`https://${window.Shopify.shop}/api/${window.API_VERSION}/graphql.json`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/graphql",
//       "X-Shopify-Storefront-Access-Token": window.API_ACCESS
//     },
//     body: payload
//   })
// }


// /* 
//   Product Card Bundle Prices
//   TODO: Store price as sessionStorage and render if already fetched.
//   */
// async function fetchBundleProducts(bundleTag, bundleID) {

//   var bundledProducts = [];

//   let bundleTagParts = bundleTag.split('|');
//   var bundlePercentage = bundleTagParts[1].split(':')[1];
//   var bundleItemsTotal = parseInt(bundleTagParts[2].split(':')[1]);
//   var bundleTotalCost = 0;
//   var bundleTotalCostDisplay = 0;
//   var bundleDiscountCostDisplay = 0
//   var bundleItemPos = 0;
//   var priceWrapEl = document.getElementById(bundleID);
//   var priceEl = priceWrapEl.querySelector('.price');
//   var priceRegularWrapEl = priceEl.querySelectorAll('.price__regular');
//   var priceSaleWrapEl = priceEl.querySelectorAll('.price__sale');
//   var priceRegularEl = priceEl.querySelectorAll('.price-item--regular');
//   var priceSaleEl = priceEl.querySelectorAll('.price-item--sale');
//   var bundleItemHtml = '';
//   var fetchAlways = false; // setting this prevents using sessionStorage data and fetches new product data everytime

//   var sessionStorageBundleProdKey = `wc-bundle-card-prod-${bundleID}`;
//   var sessionStorageBundleProdData = sessionStorage.getItem(sessionStorageBundleProdKey);
//   var sessionStorageBundlecostKey = `wc-bundle-card-bundlecost-${bundleID}`;
//   var sessionStorageBundleCostData = sessionStorage.getItem(sessionStorageBundlecostKey);
//   var sessionStorageBundleDiscountCostKey = `wc-bundle-card-bundlediscountcost-${bundleID}`;
//   var sessionStorageBundleDiscountCostData = sessionStorage.getItem(sessionStorageBundleDiscountCostKey);


//   if (sessionStorageBundleProdData && fetchAlways != true) {
    
//     priceRegularEl.forEach(priceReg => { priceReg.innerHTML = sessionStorageBundleCostData });
//     priceSaleEl.forEach(priceSale => { priceSale.innerHTML = sessionStorageBundleDiscountCostData });

//     if(JSON.parse(sessionStorageBundleCostData) != JSON.parse(sessionStorageBundleDiscountCostData)){
//       priceRegularWrapEl.forEach(priceReg => { priceReg.classList.add('hidden')});
//       priceSaleWrapEl.forEach(priceSale => { priceSale.style.display = 'block'});
//     }else{
//       priceRegularWrapEl.forEach(priceReg => { priceReg.classList.remove('hidden')});
//       priceSaleWrapEl.forEach(priceSale => { priceSale.style.display = 'none'});
//     }

//     priceEl.classList.remove('visually-hidden');

//   }else{

//     let payload = `{
//       products(first: 10, query:"tag:'${bundleTag}'") {
//         edges {
//           node {
//             id
//             title
//             handle
//             onlineStoreUrl
//           }
//         }
//       }
//     }`

//     let resp = await window.fostrFetch(payload)

//     if (!resp.ok) {
//       throw new Error(`HTTP error! status: ${resp.status}`)
//     }

//     var bundledProductFetch = (await resp.json()).data.products.edges

//     await bundledProductFetch.forEach(product => {
//       let product_id = product.node.id.split('/').reverse()[0];
//       if (product_id != bundleID){
//         bundledProducts.push(product.node.handle)
//       }
//     });

//     bundledProducts.forEach(productHandle => {

//       fetch(`${window.shopUrl}/products/${productHandle}/?view=bundle-item&currency=${window.Shopify.currency.active}`)
//       .then(response => response.text())
//       .then((responseText) => {
//         html = new DOMParser().parseFromString(responseText, 'text/html')

//         bundleItemPos = bundleItemPos + 1;
//         currentProductAvailable = html.querySelector('.wc-bundle-item-container .price').dataset.available;
//         currentProductPrice =  parseInt(html.querySelector('.wc-bundle-item-container .price').dataset.bundleprice);
//         currentProductHtml =  html.querySelector('.wc-bundle-item-container').outerHTML;
//         bundleTotalCost = bundleTotalCost + currentProductPrice;

//         bundleItemHtml = bundleItemHtml + currentProductHtml;

//         if(currentProductAvailable == 'false'){
//           bundleAvailable = false;
//         }

//         if(bundleItemPos < bundleItemsTotal){
//         }else{
//           bundleDiscount = parseFloat((bundleTotalCost * bundlePercentage) / 100).toPrecision(12);
//           bundleDiscountCost = parseFloat(bundleTotalCost - bundleDiscount).toPrecision(12);
//           bundleTotalCost = parseFloat(bundleTotalCost / 100).toFixed(2);
//           bundleDiscountCost = parseFloat(bundleDiscountCost / 100).toFixed(2);
    
//           bundleTotalCostDisplay = `${window.currencySymbol}`+ bundleTotalCost;
//           bundleDiscountCostDisplay = `${window.currencySymbol}`+ bundleDiscountCost;
          
//           priceRegularEl.forEach(priceReg => { priceReg.innerHTML = bundleTotalCostDisplay });
//           priceSaleEl.forEach(priceSale => { priceSale.innerHTML = bundleDiscountCostDisplay });
    
//           if(parseInt(bundleTotalCost) > parseInt(bundleDiscountCost)){
//             priceRegularWrapEl.forEach(priceReg => { priceReg.classList.add('hidden')});
//             priceSaleWrapEl.forEach(priceSale => { priceSale.style.display = 'block'});
//           }else{
//             priceRegularWrapEl.forEach(priceReg => { priceReg.classList.remove('hidden')});
//             priceSaleWrapEl.forEach(priceSale => { priceSale.style.display = 'none'});
//           }

//           priceEl.classList.remove('visually-hidden');

//           sessionStorage.setItem(sessionStorageBundleProdKey, JSON.stringify(bundleItemHtml));
//           sessionStorage.setItem(sessionStorageBundlecostKey, JSON.stringify(bundleTotalCostDisplay));
//           sessionStorage.setItem(sessionStorageBundleDiscountCostKey, JSON.stringify(bundleDiscountCostDisplay))

//         }

//       })
//       .catch(error => {
//         console.log(error)
//       })

//     });

//   }

// }

window.addEventListener('load', () => {
  const wcBundleProductCard = (element, bundleTag, bundleID) => {
    fetchBundleProducts(bundleTag, bundleID);
  }
  document.querySelectorAll('wc-product-card.wc-bundle').forEach(element => {
    wcBundleProductCard(element, element.dataset.bundletag, element.getAttribute('id'));
  });
});